import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "./../../redux/actions/menuActions";
import MenuSidely from "./Menu";
import _ from "lodash";
import AuthRender from "../../containers/AuthRender";
import { SERVICES } from "../../configs/constants";
import { Route, Redirect } from "react-router";
class SidelyHome extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("sidely");
    this.props.setMenuLeftIndex("home");
    this.props.setMenuLeftItemIndex("");
    this.props.setMenuLeftContent(MenuSidely);
  }
  render() {
    return (
      <div className="p-landing">
        CONTENU
        <br />
        RELATIF
        <br />
        A SIDELY
        <br />
      </div>
      
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const currentClient = state.currentClient || {};
  const currentClientId = currentClient.id || 0;
  const currentUser = state.userInfos || {};
  const currentUserClients = currentUser.clients || [];
  const currentUserClient = _.find(currentUserClients, { id: currentClientId }) || {};
  const currentUserClientServices = currentUserClient.services || [];

  return {
    currentServices: currentUserClientServices,
    currentRoleId: currentUser.role_id || 100
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidelyHome);



// WEBPACK FOOTER //
// src/pages/sidely/Sidely.home.js